import { Component, OnInit, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import { CatagoryData } from '@catalog/catalog-thumbnail/catalog-thumbnail.model';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { NgForm } from '@angular/forms';
import { FileInputComponent } from '@common/file-input/file-input';
import { MatSelectChange } from '@angular/material/select';
import { MAX_FILE_SIZE, Maximum_image_upload_file_size_2mb, format_not_allowed, Please_upload_Image} from '@root/app.constant';


@Component({
  selector: 'app-uplaod-thumbnail',
  templateUrl: './uplaod-thumbnail.component.html',
  styleUrls: ['./uplaod-thumbnail.component.scss']
})
export class UplaodThumbnailComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  @ViewChild(FileInputComponent, { static: false })  fileInputComponent: FileInputComponent;

  @Input()
  set articleList(value: any[]){
      this._articleList = value;
      this.onChangeArticleList();
  }
  get articleList():any[]{
    return this._articleList;
  }

  @Input() 
  set data(value:any){
    if(value) {
      this.catagoryData = value as CatagoryData;
      this.readonly = !!this.catagoryData.thumbnailImage;
      if(this.catagoryData.type){
        this.typeChange.emit(this.catagoryData.type);
      }
    }
  }

  get data():any{
    return this._data;
  }

  @Output() typeChange = new EventEmitter<string>();

  private _articleList = [];

  private _data:any;
 
  catagoryData = new CatagoryData();



  articleMap: {[key:string]: any} = {};

  file: File;

  fileName: string;

  @Input() typeList : any;

  readonly: boolean = false;

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandler
  ) {}

  ngOnInit() {
   
  }
  public onFileChange(file: File) {
    this.file = file;
    if (this.file) {
      let isValid =  true;
      const fsize = this.file.size;
      if (fsize > MAX_FILE_SIZE) {
        this.toastr.error(Maximum_image_upload_file_size_2mb);
        isValid = false;
      } else  if (this.file.type !== 'image/jpeg' && this.file.type !== 'image/png') {
        this.toastr.error(format_not_allowed);
        isValid = false;
      }

      if(!isValid){
        this.clearFileComponent();
      }
    } else {
      this.fileName = null;
    }
  }

  private clearFileComponent(){
    if( this.fileInputComponent){
      this.fileInputComponent.clear();
      this.file = null;
      setTimeout(() => {
        this.fileName = null;
      });
    }
  }

  public onTypeChange(change: MatSelectChange) {
    this.catagoryData = new CatagoryData();
    this.catagoryData.type = change.value;
    this.emitTypeChange(this.catagoryData.type);
  }

  public emitTypeChange(type: string) {
    this.typeChange.emit(type);
  }

  public onChangeArticleList(){
    this.articleList.forEach(a=>{
      this.articleMap[a.title]=a;
    });

    if(this.catagoryData && this.catagoryData.title &&  this.articleMap[this.catagoryData.title]){
      this.catagoryData.title = this.articleMap[this.catagoryData.title].id;
    }
  }

  public processData() {
    const formData: any = new FormData();
    if (this.file) {
      formData.append('file', this.file);
      formData.append('id', this.catagoryData.title);
    }
    this.catalogService.uploadThumbnail(formData).subscribe(
      response => {
        if(response.status === 0){
          this.toastr.success(response.message);
          this.typeChange.emit(this.catagoryData.type);
          this.resetForm(this.catagoryData.type);
        }else{
          this.errorHandler.handleError(response);
        }
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  private resetForm(type?: string) {
    this.form.resetForm();
    setTimeout(() => {
      this.catagoryData = new CatagoryData();
      this.catagoryData.type = type;
    });
  }

  public onClearThumbnail(){
    this.catagoryData.thumbnailImage = null;
    this.readonly = false;
  }

}

